module.exports = __webpack_public_path__ + "static/logo-72babba4fa1392af3e08a0e78b4b4714.svg";